function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3931",
    d: "M10 10V15",
    stroke: "#0FBC71",
    style: {
      stroke: "#0FBC71",
      stroke: "color(display-p3 0.0588 0.7373 0.4431)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1469",
    d: "M9.99984 15C8.60513 15 7.39126 15.8434 6.76455 17.0875C6.46522 17.6817 6.89474 18.3333 7.46548 18.3333H12.5342C13.1049 18.3333 13.5345 17.6817 13.2351 17.0875C12.6084 15.8434 11.3945 15 9.99984 15Z",
    stroke: "#0FBC71",
    style: {
      stroke: "#0FBC71",
      stroke: "color(display-p3 0.0588 0.7373 0.4431)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1470",
    d: "M4.1665 4.16663H3.32043C2.49833 4.16663 2.08727 4.16663 1.83331 4.4754C1.57935 4.78417 1.65382 5.12994 1.80277 5.82146C2.08729 7.14234 2.7044 8.3028 3.54059 9.16663",
    stroke: "#0FBC71",
    style: {
      stroke: "#0FBC71",
      stroke: "color(display-p3 0.0588 0.7373 0.4431)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1471",
    d: "M15.833 4.16663H16.6791C17.5012 4.16663 17.9122 4.16663 18.1662 4.4754C18.4202 4.78417 18.3457 5.12994 18.1967 5.82146C17.9122 7.14234 17.2951 8.3028 16.4589 9.16663",
    stroke: "#0FBC71",
    style: {
      stroke: "#0FBC71",
      stroke: "color(display-p3 0.0588 0.7373 0.4431)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1468",
    d: "M9.99984 9.99996C13.2215 9.99996 15.8332 7.40254 15.8332 4.19847C15.8332 4.11445 15.8314 4.03085 15.8278 3.9477C15.7922 3.11501 15.7744 2.69866 15.2101 2.18264C14.6457 1.66663 14.0204 1.66663 12.7699 1.66663H7.2298C5.97922 1.66663 5.35393 1.66663 4.7896 2.18264C4.22527 2.69866 4.20746 3.11501 4.17186 3.9477C4.1683 4.03085 4.1665 4.11445 4.1665 4.19847C4.1665 7.40254 6.77818 9.99996 9.99984 9.99996Z",
    stroke: "#0FBC71",
    style: {
      stroke: "#0FBC71",
      stroke: "color(display-p3 0.0588 0.7373 0.4431)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophyIcon.0daa9c47bab3b0961783cfc2b871baa4.svg";
export { ForwardRef as ReactComponent };